var map = {
	"./Badschrank_1_small.jpg": 7347,
	"./Badschrank_2_small.jpg": 7362,
	"./Badschrank_3_small.jpg": 3606,
	"./Bett_1_small.jpg": 3674,
	"./Bett_2_small.jpg": 5066,
	"./Buffet_1_small.jpg": 1918,
	"./Buffet_2_small.jpg": 8796,
	"./Couchtisch_1_small.jpg": 9934,
	"./Couchtisch_2_small.jpg": 3382,
	"./Matthias_1_small.jpg": 3639,
	"./Matthias_2_small.jpg": 2331,
	"./Matthias_3_small.jpg": 5984,
	"./Meister_1_small.jpg": 3268,
	"./Meister_2_small.jpg": 9979,
	"./Nachttisch_1_small.jpg": 5684,
	"./Nachttisch_2_small.jpg": 9138,
	"./Sideboard_1_small.jpg": 3871,
	"./Sideboard_2_small.jpg": 9856,
	"./Sideboard_3_small.jpg": 269,
	"./Tisch_1_small.jpg": 7024,
	"./Tisch_2_small.jpg": 8933,
	"./Tisch_3_small.jpg": 2182,
	"./Tisch_5_small.jpg": 7964,
	"./Tisch_6_small.jpg": 9093,
	"./home_both_small.jpg": 1345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4021;